<template>
  <div class="theme-content">
    <div class="block-search">
      <div class="image-text_2">
        <div class="section_8 flex-row">
          <span class="search-condtion">数据库</span>
        </div>
        <div class="search-input-box">
          <input
            type="input"
            @keyup.enter="searchSubmit"
            v-model="searchValue"
            placeholder="请输入搜索值"
            class="search-input"
          />
        </div>
        <div class="search-bnt search-bnt1 flex-col" @click="searchSubmit()">
          <span>搜索</span>
        </div>
      </div>
    </div>
    <img
      class="image_4"
      referrerpolicy="no-referrer"
      src="../../../assets/search-input-bg.png"
    />
    <div class="theme-info">
      <a
        href="https://libdbnav.fudan.edu.cn/database/navigation#/home"
        target="_blank"
        >数据库导航</a
      >
      <a
        href="https://www.fdsm.fudan.edu.cn/app/data_base/index.html"
        target="_blank"
        >管院资源</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      showForm: false,
      searchValue: "",
      id: 3,
      name: "数据库",
      searchWay: [
        { value: "000003154", name: "中文期刊论文" },
        { value: "000015961", name: "外文期刊论文" },
        { value: "000003141", name: "学位论文" },
        { value: "000015962", name: "会议论文" },
      ],
      info: "说明：万得资讯 ·PROQUEST ABI/INFORM。",
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.isPosition = to.path === "/home";
      },
      immediate: true,
    },
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
  },
  methods: {
    searchSubmit() {
      if (this.searchValue) {
        // let form = document.getElementById("cgForm");
        // form.submit();
        window.open(
          `https://libdbnav.fudan.edu.cn/database/navigation#/home?name=${this.searchValue}`
        );
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.form-box {
  display: none;
}
.block-search {
  // width: 1228px;
  // margin: 19px 0 0 133px;
  margin-top: 30px;
  height: 58px;
  background: #fff;

  .section_8 {
    background-color: rgba(0, 72, 150, 1);
    width: 157px;
    height: 57px;
    position: relative;
    cursor: pointer;
  }

  .search-condtion {
    width: 143px;
    height: 22px;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    text-align: center;
    white-space: nowrap;
    line-height: 33px;
    margin: 14px 0 0 0;
    padding: 0px 6px;
    font-size: 18px;
    font-weight: 700;
  }

  .search-input-box {
    flex: 1;
    .search-input {
      // width: 800px;
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: 0 0;
      font-size: 16px;
      letter-spacing: 0;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      padding: 0;
      border: 0;
      outline: 0;
      margin-left: 40px;
    }
  }
}

.image-text_2 {
  display: flex;
  align-items: center;
  padding-right: 20px;
}

.search-bnt {
  height: 48px;
  line-height: 48px;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-weight: 900;
  border-radius: 5px;
  cursor: pointer;
}

.search-bnt1 {
  background-color: rgba(236, 108, 0, 1);
  width: 106px;
  // margin: 5px 0 0 790px;
  margin-left: auto;
}

.image_4 {
  position: relative;
  height: 2px;
  top: -10px;
  width: 100%;
  // width: 1057px;
  // margin: -10px 0 0 303px;
}

.theme-info {
  width: 612px;
  color: rgba(51, 51, 51, 1);
  font-size: 17px;
  text-align: left;
  line-height: 26px;
  // margin: 0px 0 30px 305px;
  a {
    text-decoration: underline;
    margin-right: 20px;
    color: #004896;
    font-size: 16px;
    text-underline-offset: 6px; /* 下划线与文字的距离 */
  }
}
</style>
